<template>
  <v-card class="nospace approvals-list-card oms-list-table-card">
    <v-card-text class="nospace">
      <loading :active.sync="loading" />
      <ScrollableTable
        class="approvals-table-scroll oms-list-table-scroll"
        min-width="100%"
      >
      <v-data-table
        id="customerListTable"
        class="approvals-modern-table oms-list-table"
        hide-actions
        :headers="headers"
        :items="items"
        :disable-initial-sort="true"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td v-if="tabFilter == 'job'">
            <div class="oms-id-cell approvals-id-cell">
              <activityLogs
                class="approvals-row-log-button"
                :type="'jobs'"
                v-if="tabFilter == 'job'"
                :permissions="'activity-logs-jobs'"
                :_id="props.item._id"
                :id="props.item.jobId.toString()"
              />
              <span class="approvals-id-value">{{ props.item.jobId }}</span>
            </div>
          </td>

          <td v-if="tabFilter == 'sales'">
            <div class="oms-id-cell approvals-id-cell">
              <activityLogs
                class="approvals-row-log-button"
                v-if="tabFilter == 'sales'"
                :permissions="'activity-logs-jobs'"
                :type="'inquiry'"
                :id="props.item.inquiryId"
              />
              <span class="approvals-id-value">{{ props.item.inquiryId }}</span>
            </div>
          </td>
          <td class="approvals-country-cell">
            <div class="approvals-country-stack">
              <img
                v-if="props.item.workingCountry == 'PAK'"
                src="../../assets/pakflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'KSA'"
                src="../../assets/ksaflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE'"
                src="../../assets/Uaeflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE LA'"
                src="../../assets/Uaeflag.png"
                height="20px"
                style="border-radius: 50%"
              />
              <img
                v-if="props.item.workingCountry == 'OMAN'"
                src="../../assets/omanflag.png"
                height="28px"
              />
              <span>{{ props.item.workingCountry || "-" }}</span>
            </div>
          </td>
          <td v-if="tabFilter == 'job'" class="approvals-customer-cell">
            {{ props.item.customer }}
          </td>

          <td v-if="tabFilter == 'sales'" class="approvals-customer-cell">
            <div class="approvals-customer-stack">
              <strong>
                {{
                  props.item.userId && props.item.userId.companyName
                    ? props.item.userId.companyName
                    : props.item.userId && props.item.userId.name
                    ? props.item.userId.name
                    : "-"
                }}
              </strong>
              <span v-if="props.item.userId && props.item.userId.name">
                {{ props.item.userId.name }}
              </span>
              <span v-if="props.item.userId && props.item.userId.email">
                {{ props.item.userId.email }}
              </span>
            </div>
          </td>
          <td class="approvals-trucks-cell">
            {{ props.item.numberOfAssignmentsRequired }}
          </td>
          <td v-if="tabFilter == 'job'" class="approvals-date-cell">
            {{ getTime3(props.item.pickupDate) }} {{ props.item.pickUpTime }}
          </td>
          <td v-if="tabFilter == 'sales'" class="approvals-date-cell">
            {{ getTime3(props.item.bookingDate) }}
          </td>
          <td class="approvals-route-cell">
            <div class="approvals-route-stack">
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="orange"
              >
                <template slot="activator">
                  <div class="approvals-route-point">
                    <span class="approvals-route-label">From</span>
                    <strong class="approvals-route-value">
                      {{ props.item.sourceCity }},
                      {{ props.item.sourceCountry }}
                    </strong>
                  </div>
                </template>
                <span class="tooltip">{{ props.item.sourceLocation }}</span>
              </v-tooltip>
              <v-tooltip
                top
                class="milestone"
                content-class="tooltip-op"
                color="orange"
              >
                <template slot="activator">
                  <div class="approvals-route-point">
                    <span class="approvals-route-label">To</span>
                    <strong class="approvals-route-value">
                      {{ props.item.destinationCity }},
                      {{ props.item.destinationCountry }}
                    </strong>
                  </div>
                </template>
                <span class="tooltip">{{ props.item.destinationLocation }}</span>
              </v-tooltip>
            </div>
          </td>
          <td v-if="tabFilter == 'job'" class="approvals-price-cell">
            {{ props.item.jobPrice }} {{ props.item.customerCurrency }}
          </td>
          <td v-else class="approvals-price-cell">
            {{ props.item.acceptedPrice }} {{ props.item.customerCurrency }}
          </td>
          <td v-if="tabFilter == 'job'" class="approvals-status-cell">
            <span class="approvals-status-pill">
              {{ getStatus(props.item.jobStatus) }}
            </span>
          </td>
          <td v-if="tabFilter == 'sales'" class="approvals-status-cell">
            <span class="approvals-status-pill approvals-status-pill--sales">
              {{ props.item.inquiryStatus }}
            </span>
          </td>

          <td v-if="tabFilter == 'job'" class="approvals-actions-cell">
            <div class="approvals-action-stack">
              <button
                target="_blank"
                v-if="props.item.jobStatus != -1 && props.item.jobStatus == 10"
                @click="open2(props.item, props.index)"
                class="cancel-btn oms-btn oms-btn--destructive"
              >
                Reject
              </button>
              <button
                v-if="props.item.jobStatus == 10"
                class="track-ass-btn green-button m-l-5 oms-btn oms-btn--primary"
                title="Approval"
                @click="jobApproval(props.item, props.index)"
              >
                Approve
              </button>
              <button
                @click="goToProfile(props.item.jobId)"
                target="_blank"
                class="track-ass-btn m-l-5 oms-btn oms-btn--secondary"
              >
                Details
              </button>
            </div>
          </td>
          <td v-if="tabFilter == 'sales'" class="approvals-actions-cell">
            <div class="approvals-action-stack">
              <button
                target="_blank"
                v-if="props.item.inquiryStatus == 'Low Credit Limit'"
                @click="open2(props.item, props.index)"
                class="cancel-btn oms-btn oms-btn--destructive"
              >
                Reject
              </button>
              <button
                v-if="props.item.inquiryStatus == 'Low Credit Limit'"
                @click="inquiryApproval(props.item, props.index)"
                class="track-ass-btn green-button m-l-5 oms-btn oms-btn--primary"
                title="Approval"
              >
                Approve
              </button>
            </div>
          </td>
        </template>
        <v-alert
          slot="no-results"
          :value="isNoSearchResult"
          color="blue"
          icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
        <template slot="no-data">
          <div class="approvals-empty-state">No approvals available</div>
        </template>
      </v-data-table>
      </ScrollableTable>
      <pagination
        class="approvals-pagination"
        v-if="this.workingCountry"
        :totalPages="totalPages"
        :pages="this.pages"
        @pageNo="page"
        :url="`/approvals/approvalList`"
        :callback="callback"
        :componentKey="componentKey"
        :action="`tender`"
        :payload="payload"
        :type="1"
        v-on:pagination-load="checkLoading"
      />
    </v-card-text>

    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
    <v-snackbar
      :timeout="6000"
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
    <v-dialog
      v-model="dialog2"
      persistent
      :max-width="options.width"
      content-class="approvals-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
          <v-toolbar-title class="white--text">{{
            cancelTitle
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-show="!!cancelMessage" class="pa-4">
          {{ cancelMessage }}
          <v-flex pt-2 pr-1>
            <div class="subheading muted caption">
              Provide cancellation reason
            </div>
            <v-select
              class="pt-0 currencyTitle"
              v-model="cancelType"
              :items="cancellationType"
              :menu-props="{ offsetY: true }"
              label="Select your option"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-flex>
          <v-flex>
            <div
              v-if="cancelType.value == 'Other’s'"
              class="subheading muted caption"
            >
              Reason
            </div>
            <v-text-field
              class="pt-0 currencyTitle"
              v-if="cancelType.value == 'Other’s'"
              type="text"
              single-line
              label="Enter your reason"
              required
              v-model="cancelComments"
              :value="cancelComments"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn color="primary darken-1" text @click.native="open3">Yes</v-btn>
          <v-btn color="grey" text @click.native="cancel2">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog3"
      persistent
      :max-width="450"
      content-class="approvals-dialog approvals-dialog--success"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          flat
          class="approvals-success-toolbar"
        >
          <v-toolbar-title dark>{{ cancelTitle1 }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialog3 = false"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text
            style="text-align: center"
            v-show="!!cancelMessage1"
            class="pa-4"
          >
            <div class="pb-4">
              <img
                src="../../assets/Character-sitting.png"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ cancelMessage1 }}</div>

            <div
              v-if="cancelType.value == 'Other’s'"
              class="subheading muted pt-2"
            >
              <span style="color: darkgrey">Cancellation reason:</span>
              <p style="word-break: break-all">
                {{ cancelType.value }} - {{ cancelComments }}
              </p>
            </div>
            <div v-else class="subheading muted pt-2">
              <span style="color: darkgrey">Cancellation reason:</span>
              {{ cancelType.value }}
            </div>
          </v-card-text>

          <v-card-actions class="pt-0 pb-5 justfy_c">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text"
              darken-1
              text
              :loading="loading"
              @click.native="agree2"
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from "lodash";
import { EventBus } from "../../event-bus.js";
import Loading from "vue-loading-overlay";
import { approvalList } from "@/constants/datatable-headers.js";
import { ApiService } from "@/services/api-service";
import moment from "moment";
import activityLogs from "../Common/activityLogs";
import pagination from "@/components/Pagination/pagination";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ErrorBox from "@/components/Common/ErrorBox";
import ScrollableTable from "@/components/Common/ScrollableTable";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import { debuglog } from "util";
import { StorageKeys, CancellationType } from "../../constants/constants";
export default {
  created() {
    this.cancellationType = CancellationType;
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
      this.loading = true;
      this.payload = {
        workingCountry: this.workingCountry,
        type: this.tabFilter,
        isSearch: "true",
      };
    }
    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = val;
      this.payload.workingCountry = this.workingCountry;
    });
    this.$eventBus.$on("close-job-profile", () => {
      this.dialog = false;
      this.currentItem = null;
    });
  },
  components: {
    pagination,
    SuccessDialog,
    Loading,
    activityLogs,
    ErrorBox,
    ScrollableTable,
  },
  props: {
    loader: Boolean,
    tabFilter: String,
    searchText: String,
    dateRangenew: Array,
    reset: Boolean,
    updateList: Number,
  },
  watch: {
    dateRangenew: function (n, o) {
      if (n && n[0] && n[1]) {
        // Syncfusion can expose an intermediate start-only range while the
        // user is still picking. Apply the filter only after both dates exist.
        this.$eventBus.$emit("on-load");
        this.loading = false;
        this.startDate = moment(n[0]).format("YYYY-MM-DD");
        this.endDate = moment(n[1]).format("YYYY-MM-DD");
        this.$set(this.payload, "startDate", this.startDate);
        this.payload.endDate = this.endDate;
      } else if (!n) {
        this.startDate = "";
        this.endDate = "";
        this.$eventBus.$emit("on-load");
        this.payload = {
          type: this.tabFilter,
          isSearch: "true",
          workingCountry: this.workingCountry,
        };
      }
    },
    dateFilter: function (n, o) {
      if (n != "") {
        //this.$eventBus.$emit("on-load");
        this.$set(this.payload, "startDate", n.startDate);

        this.payload.endDate = n.endDate;
      } else {
        this.payload = {
          type: this.tabFilter,
          workingCountry: this.workingCountry,
        };
      }
    },
    pagination(val) {
      if (val["sortBy"] === "trucks") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "numberOfAssignmentsRequired";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "numberOfAssignmentsRequired";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      } else if (val["sortBy"] === "date") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "pickupDate";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "pickupDate";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      } else if (val["sortBy"] === "status") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "jobPrice";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "jobPrice";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      }

      if (!val["sortBy"]) {
        delete this.payload["sortType"];
        delete this.payload["sortBy"];
        if (val["descending"] == null) {
          this.componentKey = this.componentKey + 1;
        }
      }
      deep: true;
    },
    searchText: function (n, o) {
      if (n != "") {
        this.$eventBus.$emit("on-load");
        this.$set(this.payload, "searchText", n);
      } else {
        if (this.payload.startDate) {
          this.payload = {
            isSearch: "true",
            type: this.tabFilter,
            startDate: this.dateFilter.startDate,
            endDate: this.dateFilter.endDate,
            workingCountry: this.workingCountry,
          };
        } else {
          this.payload = {
            isSearch: "true",
            type: this.tabFilter,
            workingCountry: this.workingCountry,
          };
        }
      }
    },
    updateList: function (n) {
      this.componentKey = this.componentKey + 1;
    },
    tabFilter: function (n, o) {
      this.loading = true;
      if (n != "") {
        this.$set(this.payload, "type", n);
      } else {
        this.payload = {
          isSearch: "true",
          type: this.tabFilter,
          workingCountry: this.workingCountry,
        };
      }
    },
    reset: function (n, o) {
      if (n == true) {
        this.$eventBus.$emit("on-load");
        this.payload = {
          type: this.tabFilter,
          workingCountry: this.workingCountry,
          isSearch: "true",
        };
      }
    },
    deep: true,
    immediate: true,
  },
  data() {
    return {
      cancellationType: [],
      cancelType: "",
      newJob: 0,
      newInquiry: 0,
      startDate: "",
      endDate: "",
      statusComments: "",
      cancelTitle: null,
      dialog3: false,
      cancelMessage: null,
      cancelTitle1: null,
      cancelMessage1: null,
      dialog2: false,
      cancelComments: "",
      options: {
        color: "#ffc04c",
        width: 500,
        zIndex: 200,
      },
      pagination: {},
      workingCountry: null,
      processing: false,
      componentKey: 0,
      search: "",
      error: null,
      isNoSearchResult: false,
      loading: true,
      payload: {},
      pages: 1,
      totalPages: 0,
      x: {
        message: "",
        loading: false,
        success: false,
        menu: false,
        error: null,
      },
      headers: approvalList,
      documentData: [],
      items: [],
      executives: [],
      selectedExecutive: null,
      currentIndexForCustomer: null,
    };
  },
  methods: {
    checkLoading(event) {
      if (event) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    },
    refresh() {
      this.newJob = 0;
      this.newInquiry = 0;
    },

    jobApproval(value, status) {
      this.loading = true;
      let body = {
        jobId: value.jobId.toString(),
        underApproval: true,
      };
      ApiService.postData("/approvals/approveJob", body).then(
        (response) => {
          this.identify(localStorage.getItem("email"));
          this.track("Job Approval", {
            "Job Id": value.jobId,
            "Company Name/Customer Name":
              value.companyName || value.customer || value.customerEmail,
            "Job Start Date": moment.unix(value.startDate).format(),
            "Working Country": value.workingCountry,
            "Selling Price": value.jobPrice,
            "Approved At": moment().format().toString(),
          });
          value.jobStatus = 4;
          this.loading = false;
          this.x.success = true;
        },
        (error) => {
          this.loading = false;

          this.error = error.response.data.message;
        }
      );
    },

    page(event) {
      this.pages = event;
    },
    inquiryApproval(value, status) {
      this.loading = true;
      let body = {
        inquiryId: value.inquiryId.toString(),
        underApproval: true,
      };
      ApiService.postData("/approvals/approveInquiry", body).then(
        (response) => {
          value.jobStatus = "Approved";
          this.identify(localStorage.getItem("email"));
          this.track("Inquiry Approval", {
            "Inquiry Id": value.inquiryId,
            "Company Name/Customer Name":
              value.userId.companyName ||
              value.userId.customer ||
              value.userId.customerEmail,
            "Job Start Date": value.bookingDateTime,
            "Working Country": value.workingCountry,
            "Selling Price": value.quotedPrice,
            "Approved At": moment().format().toString(),
          });
          this.loading = false;
          this.x.success = true;
        },
        (error) => {
          this.loading = false;

          this.error = error.response.data.message;
        }
      );
    },
    open3(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      if (!this.cancelType) {
        this.error = "Please select cancellation reason before moving ahead";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return false;
      }
      if (this.cancelType.value == "Other’s") {
        if (!this.cancelComments.trim()) {
          this.error = "Please enter cancellation reason before moving ahead";
          setTimeout(() => {
            this.error = "";
          }, 3000);
          return false;
        }
      }

      this.dialog3 = true;
      this.dialog2 = false;
      this.cancelTitle1 = "Cancellation Message";

      if (this.tabFilter == "sales") {
        this.cancelMessage1 = "Your  Inquiry has been cancelled!";
      } else {
        this.cancelMessage1 = "Your  job has been cancelled!";
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    open2(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      this.currentEnquiry = val;
      this.currentIndex = index;

      this.cancelComments = "";
      this.cancelType = "";

      this.dialog2 = true;
      this.cancelTitle = "Cancel Job";
      this.cancelMessage = "On clicking YES this job will be cancelled";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree2() {
      this.resolve(true);
      this.cancelJob(this.currentEnquiry, this.currentStatus);
      this.dialog2 = false;
    },
    cancel2() {
      this.resolve(false);
      this.dialog2 = false;
    },
    cancelJob(value, status) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      this.loading = true;
      let body = {
        jobId: this.items[this.currentIndex].jobId.toString(),
        type: 2,
      };
      if (this.cancelType.value) {
        if (this.cancelType.value == "Other’s") {
          body.cancellationReason =
            this.cancelType.value + " - " + this.cancelComments.trim();
        } else {
          body.cancellationReason = this.cancelType.value;
        }
      }

      ApiService.postData("/dmsAdmin/cancelJob", body).then(
        (response) => {
          this.componentKey += 1;
          this.loading = false;
          this.dialog3 = false;
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
          setTimeout(function () {
            this.error = "";
          }, 3000);
        }
      );
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Approved";
        case 2:
          return "Approved";
        case 3:
          return "Approved";
        case 4:
          return "Approved";
        case 5:
          return "Approved";
        case 6:
          return "Approved";
        case 7:
          return "Approved";
        case 8:
          return "Approved";
        case 9:
          return "Approved";
        case 10:
          return "Low Credit Limit";

        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    paginationPayload(event) {
      this.payload = event;
    },
    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.$emit("on-block");
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },

    getTime(date) {
      return moment(date).format("ll");
    },
    callback(res) {
      this.$emit("off-load");
      this.loading = false;
      if (this.tabFilter == "job") {
        this.items = [...res.jobInfo];
      }
      if (this.tabFilter == "sales") {
        this.items = [...res.jobInfo];
      }

      this.totalPages = Math.ceil(res.totalData / 15);
      this.pagination.rowsPerPage = 15;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
#dataTable .theme--light.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
  color: white !important;
  margin-left: 10px !important;
}
#dataTable.theme--light.v-datatable thead th.column.sortable.active .v-icon {
  opacity: 1 !important;
  color: white !important;
  margin-left: 10px !important;
}

#nav .approvals-list-card.oms-list-table-card {
  background: #ffffff !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 var(--oms-section-x, 1.875rem) 1.5rem !important;
}

#nav .approvals-table-scroll {
  max-width: 100%;
  overflow-x: auto;
}

#nav .approvals-modern-table {
  --oms-list-col-1: 9.5%;
  --oms-list-col-2: 7%;
  --oms-list-col-3: 15.5%;
  --oms-list-col-4: 7%;
  --oms-list-col-5: 8%;
  --oms-list-col-6: 22%;
  --oms-list-col-7: 10%;
  --oms-list-col-8: 10%;
  --oms-list-col-9: 11%;
}

#nav .approvals-modern-table .v-table__overflow {
  background: #ffffff;
  border: 0.0625rem solid var(--approvals-border, #e4e1d9);
  border-radius: 0 0 0.5rem 0.5rem;
  overflow-x: auto !important;
  width: 100%;
}

#nav .approvals-modern-table table.v-table {
  border-collapse: separate;
  border-spacing: 0 0.375rem;
  min-width: var(--scrollable-table-min-width, 100%) !important;
  table-layout: fixed !important;
  width: 100%;
}

#nav .approvals-modern-table table.v-table thead th {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa !important;
  border-left: 0.0625rem solid #fed7aa !important;
  border-top: 0.0625rem solid #fed7aa !important;
  color: #9a4f08 !important;
  font-size: 0.6875rem !important;
  font-weight: 900 !important;
  height: 4.25rem !important;
  letter-spacing: 0.0625rem !important;
  line-height: 1.35 !important;
  overflow-wrap: normal !important;
  padding: 0.625rem 0.375rem !important;
  text-align: center !important;
  text-transform: uppercase;
  vertical-align: middle !important;
  white-space: normal !important;
  word-break: normal !important;
}

#nav .approvals-modern-table table.v-table thead th:last-child {
  border-right: 0.0625rem solid #fed7aa !important;
}

#nav .approvals-modern-table table.v-table thead th .v-icon {
  margin-left: 0.25rem !important;
  vertical-align: middle;
}

#nav .approvals-modern-table table.v-table thead th:first-child {
  border-top-left-radius: 0.375rem;
}

#nav .approvals-modern-table table.v-table thead th:last-child {
  border-top-right-radius: 0.375rem;
}

#nav .approvals-modern-table table.v-table tbody td {
  background: #ffffff;
  border-bottom: 0.0625rem solid #f0eee8 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0.0625rem solid #f0eee8 !important;
  color: #2f3747;
  font-size: 0.8125rem !important;
  font-weight: 700;
  height: 4.5rem !important;
  line-height: 1.35;
  overflow-wrap: anywhere;
  padding: 0.625rem 0.625rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: normal !important;
}

#nav .approvals-modern-table table.v-table tbody td:first-child {
  border-left: 0.25rem solid var(--approvals-primary, #ea7a1c) !important;
  border-radius: 0.5rem 0 0 0.5rem;
  color: var(--approvals-primary-dark, #d96a10);
  font-weight: 900;
  padding-left: 0.625rem !important;
}

#nav .approvals-modern-table table.v-table tbody td:last-child {
  border-radius: 0 0.5rem 0.5rem 0;
  border-right: 0.0625rem solid #eef1f5 !important;
}

#nav .approvals-modern-table table.v-table tbody tr:hover td {
  background: #fbfdff;
}

#nav .approvals-modern-table table.v-table tbody tr:hover td:first-child {
  border-left-color: #2563eb !important;
}

.approvals-dialog {
  max-width: 28rem !important;
}

.approvals-dialog .v-card {
  border-radius: 0.5rem !important;
  overflow: hidden;
  padding: 0 !important;
}

.approvals-dialog .v-toolbar {
  box-shadow: none !important;
  min-height: 2.75rem !important;
}

.approvals-dialog .v-toolbar__content {
  height: 2.75rem !important;
  padding: 0 0.875rem !important;
}

.approvals-dialog .v-card__text {
  color: var(--oms-ink, #3a382f);
  font-size: 0.875rem;
  line-height: 1.5;
}

.approvals-dialog .v-card__actions {
  justify-content: flex-end;
  padding: 0 0.875rem 0.875rem !important;
}

.approvals-dialog--success {
  max-width: 26rem !important;
}

.approvals-dialog--success .approvals-success-toolbar {
  background: #fff0dc !important;
  color: var(--oms-ink-strong, #1a1916) !important;
  padding-left: 0 !important;
}

.approvals-dialog--success .v-toolbar__content {
  justify-content: center;
}

.approvals-dialog--success .v-toolbar__title {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 1rem;
  font-weight: 900;
}

.approvals-dialog--success img {
  height: auto !important;
  max-width: 80vw;
  width: 16rem !important;
}
</style>

<style scoped>
.cancel-btn {
  background: #dc2626 !important;
}

.m-l-5 {
  margin-left: 0;
}

.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
}

.approvals-id-cell {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.25rem;
  justify-content: flex-start;
  min-width: 0;
}

.approvals-id-cell > div,
.approvals-id-cell .v-btn,
.approvals-id-cell button {
  flex: 0 0 auto;
  height: 1.5rem !important;
  margin: 0 !important;
  min-width: 1.5rem !important;
  padding: 0 !important;
  width: 1.5rem !important;
}

.approvals-row-log-button {
  align-items: center;
  background: #fff7ed;
  border: 0.0625rem solid #fed7aa;
  border-radius: 999rem;
  box-shadow: none;
  display: inline-flex;
  height: 1.5rem !important;
  justify-content: center;
  min-width: 1.5rem !important;
  padding: 0 !important;
  width: 1.5rem !important;
}

.approvals-row-log-button ::v-deep .v-icon,
.approvals-id-cell ::v-deep .v-icon {
  color: #ea580c !important;
  display: inline-flex;
  font-size: 0.875rem !important;
  height: 0.875rem !important;
  line-height: 0.875rem !important;
  width: 0.875rem !important;
}

.approvals-id-value {
  color: #0f172a;
  display: inline-block;
  flex: 1 1 auto;
  font-size: 0.75rem;
  font-weight: 900;
  line-height: 1.12;
  min-width: 0;
  overflow: visible;
  text-align: left;
  text-overflow: clip;
  white-space: nowrap;
}

.approvals-country-stack {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  min-width: 0;
}

.approvals-country-stack img {
  flex: 0 0 auto;
  max-width: 2rem;
}

.approvals-customer-cell,
.approvals-route-cell,
.approvals-price-cell {
  overflow-wrap: anywhere;
  word-break: normal;
}

.approvals-route-stack {
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 15rem;
  min-width: 0;
  position: relative;
  text-align: center;
  width: fit-content;
}

.approvals-route-stack::before {
  border-left: 0.0625rem dashed #cbd5e1;
  bottom: 0.875rem;
  content: "";
  left: 0.1875rem;
  position: absolute;
  top: 0.875rem;
}

.approvals-route-point {
  background: transparent;
  border: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  min-width: 0;
  padding: 0 0 0 0.8125rem;
  position: relative;
  width: 100%;
}

.approvals-route-point::before {
  background: var(--approvals-primary, #ea7a1c);
  border: 0.125rem solid #fff7ed;
  border-radius: 999rem;
  box-shadow: 0 0 0 0.0625rem rgba(245, 130, 32, 0.24);
  content: "";
  height: 0.5rem;
  left: 0;
  position: absolute;
  top: 0.1875rem;
  width: 0.5rem;
  z-index: 1;
}

.approvals-route-point:last-child::before {
  background: #2563eb;
  border-color: #eff6ff;
  box-shadow: 0 0 0 0.0625rem rgba(37, 99, 235, 0.22);
}

.approvals-route-label {
  color: var(--approvals-muted, #74716a);
  display: block;
  font-size: 0.625rem;
  font-weight: 800;
  line-height: 1.2;
  padding: 0;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}

.approvals-route-value {
  color: #2f3747;
  display: -webkit-box;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.25;
  max-height: 2.45em;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: normal;
  text-align: center;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.approvals-customer-stack {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  justify-content: center;
  line-height: 1.32;
  min-width: 0;
  text-align: center;
}

.approvals-customer-stack strong,
.approvals-customer-stack span {
  display: block;
  max-width: 100%;
  overflow-wrap: anywhere;
  white-space: normal;
}

.approvals-customer-stack strong {
  color: var(--oms-ink-strong, #1a1916);
  font-size: 0.8125rem;
  font-weight: 900;
}

.approvals-customer-stack span {
  color: var(--oms-muted, #74716a);
  font-size: 0.75rem;
  font-weight: 700;
}

.approvals-status-cell,
.approvals-actions-cell {
  overflow-wrap: normal !important;
  text-align: center !important;
  word-break: normal !important;
}

.approvals-status-pill {
  align-items: center;
  background: #f1f5f9;
  border: 0.0625rem solid #e2e8f0;
  border-radius: 999rem;
  color: #334155;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 900;
  justify-content: center;
  line-height: 1.15;
  max-width: 8rem;
  min-width: 5.75rem;
  min-height: 1.625rem;
  overflow-wrap: normal;
  padding: 0.3125rem 0.625rem;
  text-align: center;
  word-break: normal;
  white-space: normal;
}

.approvals-status-pill--sales {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #9a3412;
}

.approvals-action-stack {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.approvals-modern-table ::v-deep .track-ass-btn,
.approvals-modern-table ::v-deep .cancel-btn {
  align-items: center !important;
  border: 0 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.3125rem 0.75rem rgba(245, 130, 32, 0.22) !important;
  color: #ffffff !important;
  display: inline-flex !important;
  font-size: 0.75rem !important;
  font-weight: 900 !important;
  justify-content: center;
  line-height: 1.15 !important;
  margin: 0 !important;
  max-width: 6.5rem;
  min-height: 2.125rem !important;
  min-width: 4.75rem;
  padding: 0.5rem 0.75rem !important;
  text-decoration: none !important;
  white-space: normal !important;
  width: 100%;
  word-break: normal;
}

.approvals-modern-table ::v-deep .track-ass-btn {
  background: #f58220 !important;
}

.approvals-modern-table ::v-deep .green-button {
  background: #16a34a !important;
  box-shadow: 0 0.3125rem 0.75rem rgba(22, 163, 74, 0.2) !important;
}

.approvals-empty-state {
  align-items: center;
  color: var(--oms-muted, #74716a);
  display: flex;
  font-size: 0.875rem;
  font-weight: 800;
  justify-content: center;
  min-height: 4rem;
  text-align: center;
  width: 100%;
}

.approvals-pagination {
  background: #ffffff;
  border: 0.0625rem solid var(--oms-border, #e4e1d9);
  border-radius: 0.5rem;
  margin: 0.75rem var(--oms-section-x, 1.875rem) 0;
  padding: 0.625rem !important;
}

.approvals-pagination ::v-deep .pagination_wrapper {
  padding: 0 !important;
}

.approvals-pagination ::v-deep .v-pagination {
  align-items: center;
  gap: 0.25rem;
}

.approvals-pagination ::v-deep .v-pagination__item,
.approvals-pagination ::v-deep .v-pagination__navigation {
  border-radius: 0.375rem !important;
  height: 2rem !important;
  margin: 0 0.125rem !important;
  min-width: 2rem !important;
}

@media (max-width: 47.5rem) {
  .approvals-pagination {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
</style>
